<template>
  <v-layout justify-center>
    <v-flex>

      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <h1>
              <b>PRE-CONFIRMATION APPRAISAL</b>
            </h1>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12 md3 class="text-xs-center">
            <v-select
              :items="hubs"
              v-model="selected.hub"
              solo
              @change="hub_onchange($event)"
              style="cursor:pointer;"
              item-value="name"
              item-text="name"
              label="hub"
              hide-details
            ></v-select>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-select
              :items="appraisal_types"
              v-model="selected.appraisal_type"
              solo
              @change="iframe_url()"
              style="cursor:pointer;"
              item-value="name"
              item-text="name"
              label="type"
              hide-details
            ></v-select>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-select
              :items="years"
              v-model="selected.year"
              solo
              @change="iframe_url()"
              style="cursor:pointer;"
              item-value="name"
              item-text="name"
              label="year"
              hide-details
            ></v-select>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-select
              :items="quarters"
              v-model="selected.quarter"
              solo
              @change="iframe_url()"
              style="cursor:pointer;"
              item-value="name"
              item-text="name"
              label="quarter"
              hide-details
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs12 md3 class="text-xs-center">
            <v-combobox
              :items="appraisees"
              v-model="selected.appraisee"
              solo
              @change="name_onchange($event)"
              style="cursor:pointer;"
              item-text="full_name"
              label="Appraisee (select your name for self-appraisal)"
            ></v-combobox>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-text-field
              v-model="selected.department"
              label="Department"
              single-line
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-text-field
              v-model="selected.jobGrade_position"
              label="Job Grade"
              single-line
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md3 class="text-xs-center">
            <v-text-field
              v-model="selected.form.form_list"
              label="Appraisal Form"
              single-line
              readonly
              disabled
              hide-details
            ></v-text-field>
          </v-flex>

        </v-layout>


        <v-layout row wrap>
          <v-flex xs12>
            <div>
              <iframe
                id="frm_window"
                frameborder="0"
                :src="selected.iframe.url"
                width="100%"
                :height="selected.iframe.height"
              ></iframe>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      
    </v-flex>
  </v-layout>
</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
import qb from "../../functions/query.builder";

export default {
  // components: {
  //   PageLayout: PageLayout
  // },
  data() {
    return {
      username: "",
      userfullname: "",
      appraisees: [],
      forms: [],
      hubs: [],
      years: [],
      quarters: [],
      appraisal_types: [],
      url:"",
      // showMenu: false,
      // menu: [
      //   {title: "Performance Appraisal", url:"appraisal_form", order:1},
      //   {title: "Appraisal Result", url:"appraisal_listing", order:2},
      // ],
      selected: {
        hub: "",
        appraisee: "",
        appraisee_username: "",
        department: "",
        year: "",
        quarter: "",
        appraisal_type: "",
        form: {},
        jobGrade_position: "",
        iframe: {
          url: "",
          height: ""
        }
      }
    };
  },
  created (){
    // auth.hideHeader(false);
  },
  computed:{
  },
  methods: {
    iframe_url: function(){
      var self=this;
      
      if (self.selected.hub && self.selected.appraisee && self.selected.department && self.selected.form.form_id && self.selected.year && self.selected.quarter && self.selected.appraisal_type) {

        self.check_rec().then(function(res){
          if(res.data.length==0){
            var url = [
              comm.form_ip,
              self.selected.form.form_id,
              "&username=",
              self.username,
              "&userfullname=",
              self.userfullname,
              "&hub=",
              self.selected.hub,
              "&department=",
              self.selected.department,
              "&appraisee=",
              self.selected.appraisee,
              "&appraisee_username=",
              self.selected.appraisee_username,
              "&year=",
              self.selected.year,
              "&quarter=",
              self.selected.quarter,
              "&appraisal_type=",
              self.selected.appraisal_type
            ];
            self.selected.iframe.url=url.join("");
          } else {
            var msg = [
              "Your appraisal for ",
              self.selected.appraisee,
              " (",
              self.selected.year,
              "-",
              self.selected.quarter,
              ": ",
              self.selected.appraisal_type,
              ") has been submitted."
            ];
            common.wMsgBox.Error(msg.join(""));
            self.selected.iframe.url="";
          }
        });
      }
    },
    check_rec: function(){
      var check = [
        "for rec in form_datas ",
        "filter contains(rec.form_id,'",
        this.selected.form.form_id,
        "') && contains(rec.submission.data.hub,'",
        this.selected.hub,
        "') && contains(rec.submission.data.department,'",
        this.selected.department,
        "') && contains(rec.submission.data.appraiseeUsername,'",
        this.selected.appraisee_username,
        "') && contains(rec.submission.data.appraiserUsername,'",
        this.username,
        "') && contains(rec.submission.data.year.name,'",
        this.selected.year,
        "') && contains(rec.submission.data.quater.name,'",
        this.selected.quarter,
        "') && contains(rec.submission.data.type.name,'",//
        this.selected.appraisal_type,//
        "') return 1"
      ]
      check = check.join("");
      return comm.getFormData(check);
    },
    hub_onchange: async function(e) {
      this.get_employee(e);
      this.selected.appraisee = "";
      this.selected.department = "";
      this.selected.form = {};
      this.selected.iframe.url = "";
    },

    name_onchange: async function(e) {
      var appraisee_rec = e;
      // this.selected.iframe.url = "";

      if(e["id"]  == undefined){
        return common.wMsgBox.Error("Invalid appraisee.");
      }
      await this.get_derpartment(appraisee_rec);
      this.selected.appraisee = appraisee_rec.full_name;
      this.selected.appraisee_username = appraisee_rec.user__username;
      this.selected.jobGrade_position = appraisee_rec.emp_jg_position__job_grade__name + " - " + appraisee_rec.emp_jg_position__position__desc;
      this.get_form(appraisee_rec);
      this.iframe_url();
    },

    get_derpartment: async function(e) {
      this.selected.department = "";

      let cls_qb = new qb.QueryBuilder();
      cls_qb.Method = "all";

      cls_qb.Table = "emps_dept_employee";
      cls_qb.Select = ["emp__id", "dept__name"];

      var rule = new qb.Rule();
      rule
        .field("emp__id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(e.id);
      cls_qb.addRule(rule);

      // cls_qb.Order = ["full_name"];
      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        if (result.data.Body.records.length > 0) {
          this.selected.department = result.data.Body.records[0].dept__name;
        } else {
          common.wMsgBox.Info(
            "Contact administrator for department configuration."
          );
        }
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },

    get_form: function(e) {
      this.selected.iframe.url = "";
      var showForm = false;
      var form_rec = [];

      for (var i = 0, m = this.forms.length; i < m; i++) {
        var tt = this.forms[i];

        if (tt.form_name == e.emp_jg_position__position__jd_form) {
          showForm = true;
          form_rec = tt;
          break;
        } 
      }
      // this.selected.form = form_rec;

      if (showForm) {
        this.selected.form = form_rec;
        
        // this.selected.iframe.url =
        //   "http://192.168.22.227:5651/form?form_id=" +
        //   form_rec.form_id +
        //   "&username=" +
        //   this.username +
        //   "&userfullname=" +
        //   this.userfullname +
        //   "&hub=" +
        //   this.selected.hub +
        //   "&department=" +
        //   this.selected.department +
        //   "&appraisee=" +
        //   e.full_name +
        //   "&appraisee_username=" +
        //   e.user__username +
        //   "&year=" +
        //   this.selected.year +
        //   "&quarter=" +
        //   this.selected.quarter +
        //   "&appraisal_type=" +
        //   this.selected.appraisal_type;
      } else {
        this.selected.form = {};
        common.wMsgBox.Error("Undefined appraisal form.");
      }
    },

    // get_jobGrade_position: async function(appraisee_rec) {
    //   console.log(appraisee_rec);
    // },

    get_employee: async function(company_name) {
      let cls_qb = new qb.QueryBuilder();
      cls_qb.Method = "all";

      // NOTE: call for employee listing
      cls_qb.Table = "emps_employee";
      cls_qb.Select = [
        "id",
        "full_name",
        "user__username",
        "emp_jg_position__position__jd_form",
        "emp_jg_position__position__desc",
        "emp_jg_position__job_grade__name",
        "cost_center__name",
        "cost_center__company__name"
      ];

      var rule = new qb.Rule();
      rule
        .field("cost_center__company__name")
        .operator(qb.STR_OPERATOR.I_EQUAL)
        .value(company_name);
      cls_qb.addRule(rule);

      // OWK: only active staffs
      rule = new qb.Rule();
      rule
        .field("emp_status_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(1);
      cls_qb.addRule(rule);

      cls_qb.Order = ["full_name"];
      let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

      if (result.data.Status == 1) {
        this.appraisees = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    // },

    // viewMenu() {
    //   this.showMenu = true; 
    // },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ name: action_name });
    }

  },
  // watch:{
  //   "selected.appraisee":function(old,new1 ){
  //     debugger;
  //   }
  // },
  mounted: async function() {
    // window.document.title="Talent Mgmt";
    this.username = auth.getUsername();
    this.userfullname = auth.getFullName();
    this.selected.hub = auth.getHub();
    this.get_employee(this.selected.hub);

    var forms = await comm.getFormData(
      'for rec in forms filter contains(rec.name,"Form 47") and rec.status == 1 return {"form_id":rec._id, "form_name":rec.name, "form_list": concat(rec.name," - ",rec.description)}'
    );
    this.forms = forms.data;

    // NOTE: call for year listing
    var years = await comm.getFormData(
      'for rec in setting_year filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
    );
    this.years = years.data;

    // NOTE: call for quarter listing
    var quarters = await comm.getFormData(
      'for rec in setting_quater filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
    );
    this.quarters = quarters.data;

    // NOTE: call for appraisal_type listing
    var appraisal_types = await comm.getFormData(
      'for rec in setting_appraisal_type filter rec.status == 1  && like(rec.name, "%pre-confirmation%", true) sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
    );
    this.appraisal_types = appraisal_types.data;

    // NOTE: call for company listing
    let cls_qb = new qb.QueryBuilder();
    cls_qb.Method = "all";
    cls_qb.Table = "emps_company";
    cls_qb.Select = ["id", "name", "parent_company_id__name"];

    var rule = new qb.Rule();
    rule
      .field("parent_company_id__name")
      .operator(qb.STR_OPERATOR.I_CONTAINS)
      .value("group");
    cls_qb.addRule(rule);

    cls_qb.Order = ["name"];
    var result = await common.wBackEndComm.PostData("process_qb/", cls_qb);

    if (result.data.Status == 1) {
      this.hubs = result.data.Body.records;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }

    var self = this;

    function handleMessage(e) {
      if (e.data.event == "form_data_saved") {
        // common.wMsgBox.Success("Record successfully submitted.");
        self.selected.iframe.height = e.data.window.height;

        //common.wMsgBox.Success("Record sucessfully updated.");
        // common.wMsgBox.Success(JSON.stringify(e));
      }
      if (e.data.event == "form_loaded") {
        self.selected.iframe.height = e.data.window.height + 350;
      }
    }

    window.addEventListener("message", handleMessage, false);
  }
};
</script>

<style>
</style>
